<div class="page-container">

  <app-all-leads-list></app-all-leads-list>


  <mat-accordion multi class="card-accordion">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="icon">map</mat-icon>
          {{ "components.all-leads-view.all-leads" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content-wrapper">
        <app-map></app-map>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <mat-icon class="icon">stars</mat-icon>
          {{ "components.all-leads-view.selected-leads" | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content-wrapper">
        <app-selected-leads-preview></app-selected-leads-preview>
      </div>
    </mat-expansion-panel>

  </mat-accordion>
</div>
